// extracted by mini-css-extract-plugin
module.exports = {"marketing__cta":"cta_marketing__cta__6g4_M","marketing__cta_blue":"cta_marketing__cta_blue__QUDOh","marketing_cta_tailicon":"cta_marketing_cta_tailicon__NNBQ9"};